export default {
  maxFetchSize: 1000,
  bookingMaxFetchSize: 1000000,
}
